import { Environments, getEnvByHostname } from '@product/cabify-environments';

import { config as devConfig } from './dev';
import { config as distConfig } from './dist';
import { config as testingConfig } from './testing';

export interface ApplicationConfig {
  appEnv: Environments;
  url: {
    apiBase: string;
  };
}

const appEnv = getEnvByHostname();

const configMap: Record<Environments, ApplicationConfig> = {
  [Environments.DEV]: devConfig,
  [Environments.DEV_DIST]: devConfig,
  [Environments.PRODUCTION]: distConfig,
  [Environments.SANDBOX]: testingConfig,
  [Environments.TESTING]: testingConfig,
  [Environments.UNIT_TEST]: devConfig,
};

const config = configMap[appEnv];

export { config };
